import { getDailyData } from "../bookingapi/booking.operations";

let total = 10;

export const getDailyRecords = async (day, month, year, setDailyData) => {
  try {
    const data = await getDailyData(day, month, year);
    setDailyData(data[0]);

    const temp = {};

    data[0].bookings?.map((node) => {
      let timeSlot = node?.timeSlotId?.slotTime;

      if (!(timeSlot in temp)) {
        temp[timeSlot] = {
          booked: 1,
          available: total - 1,
        };
      } else {
        temp[timeSlot] = {
          booked: temp[timeSlot].booked + 1,
          available: temp[timeSlot].available - 1,
        };
      }
    });
  } catch (error) {
    console.error("Error fetching daily records:", error);
  }
};
